import { Filter } from 'lucide-react'

export type PeriodoFiltro = 'hoje' | 'semana' | 'mes' | 'custom'

interface Props {
  periodo: PeriodoFiltro
  setPeriodo: (p: PeriodoFiltro) => void
  obraFiltro: string
  setObraFiltro: (id: string) => void
  obras: { id: string; nome: string }[]
}

export default function DashboardFilters({ periodo, setPeriodo, obraFiltro, setObraFiltro, obras }: Props) {
  const opcoes: { key: PeriodoFiltro; label: string }[] = [
    { key: 'hoje', label: 'Hoje' },
    { key: 'semana', label: 'Esta semana' },
    { key: 'mes', label: 'Este mês' },
  ]

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <Filter size={14} className="text-muted-foreground" />
      {opcoes.map(op => (
        <button
          key={op.key}
          onClick={() => setPeriodo(op.key)}
          className="px-3 py-1.5 rounded-lg text-xs font-semibold transition-all"
          style={{
            background: periodo === op.key ? 'hsl(var(--amber-bg))' : 'hsl(var(--bg3))',
            color: periodo === op.key ? 'hsl(var(--amber))' : 'hsl(var(--txt2))',
          }}
        >
          {op.label}
        </button>
      ))}
      <select
        value={obraFiltro}
        onChange={e => setObraFiltro(e.target.value)}
        className="ml-auto text-xs px-2 py-1.5 rounded-lg bg-transparent border text-foreground"
        style={{ borderColor: 'hsl(var(--border))' }}
      >
        <option value="all">Todas as obras</option>
        {obras.map(o => <option key={o.id} value={o.id}>{o.nome}</option>)}
      </select>
    </div>
  )
}
